export const __computeConstructionAndThreadCount = (val1, val2) => {
    return val1 ? `${val1} x ${val2}` : '--'
  }